import { formatQuantity } from "@common/utils/string";
import { IAddOnSlotProps } from "../types";
import UsageGraph from "@components/ui/usage/UsageGraph";

export default function MetabotUsageGraph({ addOn }: IAddOnSlotProps) {
  const usage = addOn.getUsage();

  if (!usage) {
    return null;
  }

  return (
    <UsageGraph
      hasQuota={usage.hasQuota}
      usage={usage.usage}
      prepaidUnits={usage.includedUnits}
      metricLabel="Included use"
      maxLabel={`${formatQuantity(usage.includedUnits)} requests`}
    />
  );
}
